/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SyncDefs from './defs.defs'

const $nsid = 'com.atproto.sync.listHosts'

type $nsid = typeof $nsid

export { $nsid }

type Host = {
  $type?: 'com.atproto.sync.listHosts#host'

  /**
   * Recent repo stream event sequence number. May be delayed from actual stream processing (eg, persisted cursor not in-memory cursor).
   */
  seq?: number
  status?: SyncDefs.HostStatus

  /**
   * hostname of server; not a URL (no scheme)
   */
  hostname: string
  accountCount?: number
}

export type { Host }

const host = /*#__PURE__*/ l.typedObject<Host>(
  $nsid,
  'host',
  /*#__PURE__*/ l.object({
    seq: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SyncDefs.HostStatus>(
        (() => SyncDefs.hostStatus) as any,
      ),
    ),
    hostname: /*#__PURE__*/ l.string(),
    accountCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { host }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 1000, minimum: 1 }),
      200,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  hosts: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Host>((() => host) as any)),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates upstream hosts (eg, PDS or relay instances) that this service consumes from. Implemented by relays. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
